export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"m8.8 15.9-4.2-4.2-1.4 1.4 5.6 5.6 12-12-1.4-1.4z\"/>"
};